// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".post-quantity-notice[data-v-e2df535a]{background:#f2f2f2;border:2px solid rgba(255,112,46,.5);margin-bottom:10px;padding:5px 15px}.checkout-available-from[data-v-e2df535a]{color:#930202;font-weight:700}span.non-cancelable[data-v-e2df535a]{color:#bf0202}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
